/**
 * Created by m.igrachev on 8/4/2017.
 */
const documentedProperties = [
    {
        name: "placeholder",
        type: "String",
        defaultValue: "n/a",
        isRequired: "true",
        description:
            "A placeholder to be replaced with props.children in the corresponding places in parent's text."
    }
];

export default documentedProperties;
